import { createMutation } from "@/mutations";
import { signUp } from "@/features/auth/api/session";
import type { SignUpPayload } from "@/features/auth/api/session";
import type { AxiosResponse } from "axios";

type SignUpResponse = Awaited<ReturnType<typeof signUp>> extends AxiosResponse<infer T>
  ? T
  : never;

export const useSignUpMutation = () => {
  return createMutation<SignUpResponse, SignUpPayload>({
    mutationFn: async (payload) => {
      const response = await signUp(payload);
      return response.data;
    },
  });
};

